

type StyleParams = {
    validation?: string | null | undefined;
    style?: any;
    item?: any;
};

const createStyle = ({ validation, style, item }: StyleParams) => ({
    placeholder: (provided: any) => ({
        ...provided,
        color: '#9E9E9E',
        ...style?.placeholder,
    }),
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        flex: '1',
        display: 'flex',
        width: '100% !important',
        minHeight: '100%',
        border: validation
            ? '2px solid red'
            : `${state.menuIsOpen || state.isFocused ? '1px solid #79BC61' : '1px solid #D3D6D2'}`,
        borderRadius: '6px',
        overflow: 'hidden',
        background: 'white',
        transition: 'all 0.2s ease',
        fontSize: '14px',
        paddingLeft: '6px',
        boxShadow: state.menuIsOpen || state.isFocused
            ? '0px 0px 0px 4px #E2EEDA'
            : '0px 1px 3px rgba(16, 24, 40, 0.03), 0px 2px 4px rgba(16, 24, 40, 0.05)',
        '&:hover': {
            borderColor: '#79BC61',
        },
        ...style?.control,
    }),
    menu: (baseStyles: any, state: any) => ({
        ...baseStyles,
        overflow: 'hidden',
        border: validation ? '1px solid red' : '1px solid #79BC61',
        marginTop: '4px',
        paddingLeft: '4px',
        paddingRight: '4px',
        borderRadius: '6px',
        marginBottom: '30px !important',
        whiteSpace: 'nowrap',
        position: 'absolute',
        background: '#ffffff',
        width: '100%',
        zIndex: 1000,
        boxShadow: '0px 0px 0px 4px #E2EEDA',
        ...style?.menu,
    }),
    option: (provided: any, state: any) => {
        const sizeType = {
            sm: '8px 8px',
            md: '12px 12px',
            lg: '16px 20px',
        };
        const fontSize = {
            sm: '14px',
            md: '14px',
            lg: '18px',
        };
        return {
            ...provided,
            alignItems: 'center',
            paddingLeft: '13px',
            borderRadius: '4px',
            background: state.isSelected ? '#EBF4E8' : state.isFocused ? '#F5F9F7' : '',
            color: state.isSelected ? '#598C4A' : '#000',
            transition: 'all 0.2s ease',
            cursor: state.isSelected ? 'default' : 'pointer',
            position: 'relative',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'wrap',
            padding: "12px",// TODO: Fix this
            minWidth: 0,
            fontSize: "14px", // TODO: Fix this
            margin: '1px 0px',
            ':active': {
                backgroundColor: '#E2EEDA'
            },
            ...style?.option,
        };
    },
    multiValue: (provided: any, state: any) => ({
        ...provided,
        background: '#C2E1B7',
        paddingLeft: '4px',
        paddingRight: '0px',
        borderRadius: '40px',
        fontSize: '16px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style?.multiValue,
    }),
    multiValueRemove: (provided: any, state: any) => ({
        ...provided,
        color: '#69A455',
        borderRadius: '48px',
        transition: 'all 0.2s ease',
        padding: '0px',
        ':hover': {
            backgroundColor: '#79BC61',
            color: 'white',
        },
        height: '22px',
        width: '22px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '2px',
        marginLeft: '5px',
        ...style?.multiValueRemove,
    }),
    container: (provided: any, state: any) => ({
        ...provided,
        ...style?.container,
    }),
    menuPortal: (provided: any, state: any) => ({
        ...provided,
        zIndex: '1000',
    }),
});

export default createStyle;
